import dashboardWidgetTemplate from './dashboardWidget.html';
import './dashboardWidget.scss';

export default angular
  .module('main.dashboardPanel.dashboardWidget', [])

  .directive('dashboardWidget', () => {
    return {
      restrict: 'E',
      transclude: true,
      template: dashboardWidgetTemplate,
      scope: {
        header: '@'
      }
    };
  })
  .name;
